var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C15.2439 0.5 19.5 4.75614 19.5 10C19.5 15.2439 15.2439 19.5 10 19.5C4.75614 19.5 0.5 15.2439 0.5 10C0.5 4.75614 4.75614 0.5 10 0.5ZM8.5 8.5H4.5V11.5H8.5V15.5H11.5V11.5H15.5V8.5H11.5V4.5H8.5V8.5Z",
    fill: "#2371C4",
    stroke: "#2371C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRow);
export default __webpack_public_path__ + "static/media/addRow.7f6f86843d0d4cbb6cf02e48177d8c91.svg";
export { ForwardRef as ReactComponent };